export default __webpack_public_path__ + "static/media/SoftCut-Preserve-01.31f6b169.jpg";